import * as React from 'react'

import UserCardIcon from '../../../../assets/icons_new/UserCard.svg'

const TableEmpty = ({ title }: { title: string }) => {
  // const { t } = useLocalize()
  // @TODO add translation
  return (
    <div className="tw-grid tw-w-full tw-place-items-center tw-text-lg tw-text-neutral tw-text-opacity-70 tw-mt-16">
      <div className="tw-flex tw-flex-col tw-items-center tw-gap-5">
        <img
          src={UserCardIcon}
          alt="User Card Icon"
          className="tw-h-10 tw-w-10 tw-opacity-40"
        />
        <p className="tw-text-xs  tw-text-content-base">
          {/* {t(title)} */}

          {title}
        </p>
      </div>
    </div>
  )
}

export default TableEmpty
